import { ActionBase } from '../../../core/store/action/ActionBase';

export const UNFINALIZE_DYNAMICDATASET = '[DynamicDataSet] Unfinalize';

export class UnfinalizeDynamicDataSetAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = UNFINALIZE_DYNAMICDATASET;

  constructor(public payload: { dynamicDataSetKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/dynamicDataSets/store/actions/UnfinalizeDynamicDataSet.ts